import React, { FC, useState, useEffect } from 'react';
import { brokenRule, checkValid } from 'utils/check-password';
import { FormControl, ContainerPasswordStyled, ContainerEyeStyled } from './styles';
interface NewPassInputProps {
  setValidation: any;
  onInputChange: (e: any, name: string) => void;
  name: string;
  isInvalidProp?: boolean;
  placeholder?: string;
  icons: any;
  value: string;
}
export interface ValidationObj {
  hasCorrectLength?: boolean;
  hasLowerCase?: boolean;
  hasUpperCase?: boolean;
  hasNumber?: boolean;
  hasSpecialChar?: boolean;
  hasNoSpecialCharacterAtBeginning?: boolean;
}

const NewPassInput: FC<NewPassInputProps> = ({
  setValidation,
  onInputChange,
  name,
  isInvalidProp,
  placeholder,
  icons,
  value,
}) => {
  const [isInvalid, setIsInvalid] = useState<boolean>();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    if(name === 'newPass' && !value){
      setIsInvalid(false);
      setValidation({});
    }
  }, [name, value]);

  const ShowPasswordIcon: any = icons['show'];
  const HidePasswordIcon: any = icons['hide'];

  const handleInputChange = (e, name: string) => {
    if(name === 'newPass'){
      const validationObject = checkValid(e.target.value);
      setValidation(validationObject);
      const isInvalidTpm = brokenRule(validationObject);
      setIsInvalid(isInvalidTpm);
    }
    onInputChange(e, name);
  };

  return (
    <ContainerPasswordStyled>
      <FormControl
        type={showPassword ? 'text' : 'password'}
        name={name}
        isInvalid={isInvalidProp || isInvalid}
        placeholder={placeholder}
        onChange={(e) => handleInputChange(e, name)}
        value={value || ''}
      />
      <ContainerEyeStyled
        onMouseDown={() => setShowPassword(true)}
        onMouseUp={() => setShowPassword(false)}
      >
        {!showPassword ?
          (
            <ShowPasswordIcon />
          ) : (
            <HidePasswordIcon />
          )
        }
      </ContainerEyeStyled>
    </ContainerPasswordStyled>
  );
};

export default NewPassInput;
